export default __webpack_public_path__ + "static/media/schmerztherapie_02.d9cff0e7.png";